import { Table } from "@mantine/core";
import HomePageTable from "./HomePageTableComponent";
import dayjs from "dayjs";
import { dateWithHourFormat } from "../../../utils/dateFormat";

const LastActivityTable = ({ items }) => {
  const rows = items.map((item, i) => (
    <Table.Tr key={`${item.userName}-${i}`}>
      <Table.Td>{item.id}</Table.Td>
      <Table.Td>{item.description}</Table.Td>
      <Table.Td>{dayjs(item.dateTime).format(dateWithHourFormat)}</Table.Td>
      <Table.Td>{item.userName}</Table.Td>
      <Table.Td>{item.userRole}</Table.Td>
      <Table.Td>{item.menu}</Table.Td>
    </Table.Tr>
  ));
  return (
    <HomePageTable>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>ID</Table.Th>
          <Table.Th>Description</Table.Th>
          <Table.Th>Date/Time</Table.Th>
          <Table.Th>User</Table.Th>
          <Table.Th>Role</Table.Th>
          <Table.Th>Menu</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </HomePageTable>
  );
};

export default LastActivityTable;
